import { useState } from 'react';
import { UserPermission } from '../../enums';
import { usePageTitle } from '../../hooks';
import { RequirePermission } from '../../security';
import { getPageTitle } from '../../utils/pages';
import {
  Container,
  InventorySearchesFilters,
  InventorySearchesTable,
  Show,
} from '../../components';
import { Nullable, InventorySearchesFilters as Filters } from '../../types';
import Reports from './partials/Reports';

const InventorySearches = () => {
  usePageTitle(getPageTitle('reports.inventorySearches'));
  const [filters, setFilters] = useState<Nullable<Filters>>(null);

  const handleSearch = (filters: Nullable<Filters>) => {
    setFilters(filters);
  };

  return (
    <RequirePermission oneOf={[UserPermission.ViewInventorySearchReports]}>
      <Reports>
        <InventorySearchesFilters onSearch={handleSearch} />
        <Container>
          <Show if={!!filters}>
            <InventorySearchesTable filters={filters} />
          </Show>
        </Container>
      </Reports>
    </RequirePermission>
  );
};

export default InventorySearches;
